'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import RadialData from './RadialData';
var hundredThousand = 100000;
var oneKb = 1000;
var oneMb = 1000000;
var threeMb = 3000000;
var fiveMb = 5000000;
var tenMb = 10000000;

var PageSizeRadialData = /*#__PURE__*/function (_RadialData) {
  _inherits(PageSizeRadialData, _RadialData);

  function PageSizeRadialData() {
    _classCallCheck(this, PageSizeRadialData);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageSizeRadialData).apply(this, arguments));
  }

  _createClass(PageSizeRadialData, [{
    key: "init",
    value: function init(grade) {
      _get(_getPrototypeOf(PageSizeRadialData.prototype), "init", this).call(this, grade);

      this.displayRecommendationValue = '< 3';
      this.displayRecommendationValueUnit = I18n.text('results.data.mb');
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, threeMb, fiveMb);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      this.score = Math.round(Math.min(grade, tenMb) / hundredThousand);
    }
    /**
     * Sets the displayValue and displayValueUnit.
     *
     * E.g.
     *
     *   grade = 2000000
     *     displayValue = 2
     *     displayValueUnit = Mb
     *
     */

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      var displayValue;
      var displayValueUnit;

      if (grade >= oneMb) {
        displayValue = parseFloat((grade / oneMb).toFixed(1));
        displayValueUnit = I18n.text('results.data.mb');
      } else if (grade >= oneKb) {
        displayValue = Math.round(grade / oneKb);
        displayValueUnit = I18n.text('results.data.kb');
      } else {
        displayValue = grade;
        displayValueUnit = I18n.text('results.data.b');
      }

      this.displayValue = displayValue;
      this.displayValueUnit = displayValueUnit;
    }
  }]);

  return PageSizeRadialData;
}(RadialData);

export default PageSizeRadialData;